import dayjs from "dayjs";

export function tableDate(
  value: string | undefined | null,
  includeTime = false,
): string {
  if (!value) return "";

  const date = dayjs(value);
  if (!date.isValid()) return "";

  return date.format(includeTime ? "MM/DD/YYYY h:mm a" : "MM/DD/YYYY");
}
